export default __webpack_public_path__ + "static/media/expYellow.cff6e700.svg";